import "./index.scss";

import React, { useEffect } from "react";
import { connect } from "react-redux";
import { changeHeaderType } from "../../redux/actions";
import Logo from "./Logo";
import Menu from "./Menu";
import animation from "../../animation";

const Header = ({ headerType, handleChangeHeaderType }) => {
  useEffect(() => {
    animation.header(handleChangeHeaderType);
  }, []);

  return (
    <div className={`header ${!headerType && "header--hide"}`}>
      <div className={`header__logo`}>
        <Logo logo={headerType} />
        <span className={`header__logo-text header__logo-title`}>Maison Art</span>
        <span
          className={`header__logo-text header__logo-type ${
            headerType === "gallery"
              ? "header__logo-type--gallery"
              : headerType === "match"
              ? "header__logo-type--match"
              : headerType === "proof"
              ? "header__logo-type--proof"
              : ""
          }`}
        >
          {headerType === "gallery"
            ? "gallery"
            : headerType === "match"
            ? "match"
            : headerType === "proof"
            ? "proof"
            : ""}
        </span>
      </div>
      {/* <div className={`header__lang`}>
        <a href="#">Language</a>
      </div> */}
      <Menu />
    </div>
  );
};

const mapStateToProps = (state) => ({
  headerType: state.headerType,
});

const mapDispatchToProps = (dispatch) => ({
  handleChangeHeaderType: (value) => dispatch(changeHeaderType(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
